import {
  CHANGE_INPUT,
  CHANGE_INPUT_ERROR,
  CHANGE_STEP,
  REGISTER_GUIDED_STEP_FOUR,
  REGISTER_GUIDED_STEP_FOUR_FAILURE,
  REGISTER_GUIDED_STEP_FOUR_SUCCESS,
  REGISTER_GUIDED_STEP_FOUR_VALIDATION_FAILURE,
  REGISTER_GUIDED_STEP_THREE,
  REGISTER_GUIDED_STEP_THREE_FAILURE,
  REGISTER_GUIDED_STEP_THREE_SUCCESS,
  REGISTER_RESEND_CHANGE_EMAIL,
  REGISTER_RESEND_EMAIL,
  REGISTER_RESEND_EMAIL_FAILURE,
  REGISTER_RESEND_EMAIL_SUCCESS,
  REGISTER_RESEND_EMAIL_VALIDATION_FAILURE,
  REGISTER_STEP_ONE,
  REGISTER_STEP_ONE_FAILURE,
  REGISTER_STEP_ONE_SUCCESS,
  REGISTER_STEP_TWO,
  REGISTER_STEP_TWO_FAILURE,
  REGISTER_STEP_TWO_SUCCESS,
  REGISTER_STEP_TWO_VALIDATION_FAILURE,
  REGISTER_VERIFY,
  REGISTER_VERIFY_FAILURE,
  REGISTER_VERIFY_SUCCESS,
  RESET_INPUTS,
  RESET_INPUT_ERRORS,
  RESET_STATE,
  UPDATE_REGISTER_CURRENT_EMAIL,
  VERIFY_RECAPTCHA,
  VERIFY_RECAPTCHA_FAILURE,
  VERIFY_RECAPTCHA_SUCCESS,
} from './constants';

/**
 * @description updates input for the forms
 */
export function changeInput({
  field,
  form,
  value,
}) {
  return {
    payload: {
      field,
      form,
      value,
    },
    type: CHANGE_INPUT,
  };
}

/**
 * @description updates input error for the forms
 */
export function changeInputError({
  field,
  form,
  value,
}) {
  return {
    payload: {
      field,
      form,
      value,
    },
    type: CHANGE_INPUT_ERROR,
  };
}

/**
 * @description updates step
 */
export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

/**
 * @description Validate the user name and password. Final step in the CSR Guided Registration
 * workflow.
 */
export function registerGuidedStepFour(payload) {
  return {
    payload,
    type: REGISTER_GUIDED_STEP_FOUR,
  };
}

export function registerGuidedStepFourFailure(error) {
  return {
    payload: { error },
    type: REGISTER_GUIDED_STEP_FOUR_FAILURE,
  };
}

export function registerGuidedStepFourSuccess() {
  return { type: REGISTER_GUIDED_STEP_FOUR_SUCCESS };
}

/**
 * @description On failed Guided Registration Step Four request due to username/password validation
 * errors, action will update input error states and bannerError state.
 */
export function registerGuidedStepFourValidationFailure(payload) {
  return {
    payload,
    type: REGISTER_GUIDED_STEP_FOUR_VALIDATION_FAILURE,
  };
}

/**
 * @description Validate the Query string from the Registration link request sent in
 * Step Two of the CSR Guided Registration workflow
 */
export function registerGuidedStepThree(queryStringValue) {
  return {
    payload: { queryStringValue },
    type: REGISTER_GUIDED_STEP_THREE,
  };
}

/**
 * @description On failed Guided Step Three request, action updates serviceError state.
 */
export function registerGuidedStepThreeFailure(error) {
  return {
    payload: { error },
    type: REGISTER_GUIDED_STEP_THREE_FAILURE,
  };
}

/**
 * @description On successful Guided Step Three request, action updates registration
 * token state.
 */
export function registerGuidedStepThreeSuccess(token) {
  return {
    payload: { token },
    type: REGISTER_GUIDED_STEP_THREE_SUCCESS,
  };
}

/**
 * @description On click on the "Wrong Email?" link on the Register Resend Verification email view,
 * action will update state to display different input group.
 */
export function registerResendChangeEmail() {
  return { type: REGISTER_RESEND_CHANGE_EMAIL };
}

/**
 * @description On click on the "Resend" button on the Register Resend view, action will make a
 * request to the Register Resend route handler.
 */
export function registerResendEmail(payload) {
  return {
    payload,
    type: REGISTER_RESEND_EMAIL,
  };
}

/**
 * @description On failed Register Resend request, action will update error state.
 */
export function registerResendEmailFailure(error) {
  return {
    payload: { error },
    type: REGISTER_RESEND_EMAIL_FAILURE,
  };
}

/**
 * @description On failed Register Resend request due to validation errors, action will
 * update input error states and bannerError state.
 */
export function registerResendEmailValidationFailure(payload) {
  return {
    payload,
    type: REGISTER_RESEND_EMAIL_VALIDATION_FAILURE,
  };
}

/**
 * @description On successful Register Resend request, action will navigate the user to the
 * registration "Check Your Email" confirmation page.
 */
export function registerResendEmailSuccess(payload) {
  return {
    payload,
    type: REGISTER_RESEND_EMAIL_SUCCESS,
  };
}

/**
 * @description On submit of the Register Step One Form, action will send
 * request to Register Step One route handler
 */
export function registerStepOne(payload) {
  return {
    payload,
    type: REGISTER_STEP_ONE,
  };
}

/**
 * @description On failed Register Step One request, action will update service error
 */
export function registerStepOneFailure(error) {
  return {
    payload: { error },
    type: REGISTER_STEP_ONE_FAILURE,
  };
}

/**
 * @description On successful Register Step One request, action will store Registration
 * token in state and navigate the user to the registration consent page.
 */
export function registerStepOneSuccess(payload) {
  return {
    payload,
    type: REGISTER_STEP_ONE_SUCCESS,
  };
}

/**
 * @description On submit of the Register Step Two Form, action
 * will send request to Register Step Two route handler
 */
export function registerStepTwo(payload) {
  return {
    payload,
    type: REGISTER_STEP_TWO,
  };
}

/**
 * @description On failed Register Step Two request, action will update service error
 */
export function registerStepTwoFailure(error) {
  return {
    payload: { error },
    type: REGISTER_STEP_TWO_FAILURE,
  };
}

/**
 * @description On failed Register Step Two request due to validation errors, action will
 * update input error states and bannerError state. If there is an issue with the registration
 * token, action will route users back to page 1 of the Registration flow.
 */
export function registerStepTwoValidationFailure(payload) {
  return {
    payload,
    type: REGISTER_STEP_TWO_VALIDATION_FAILURE,
  };
}

/**
 * @description On successful Register Step Two request, action will navigate the user to the
 * registration "Check Your Email" confirmation page.
 */
export function registerStepTwoSuccess() {
  return { type: REGISTER_STEP_TWO_SUCCESS };
}

/*
 * @description When the user clicks on the registration verification link in their email,
 * on page load this action will make a request to the Register Verify route handler with
 * the API query param.
 */
export function registerVerify(payload) {
  return {
    payload,
    type: REGISTER_VERIFY,
  };
}

/**
 * @description On failed Register Verify request, action will update error state and display
 * Register Verify Confirmation Failure view.
 */
export function registerVerifyFailure(error) {
  return {
    payload: { error },
    type: REGISTER_VERIFY_FAILURE,
  };
}

/**
 * @description On successful Register Verify request, action will display the Register
 * Verify Confirmation Success view.
 */
export function registerVerifySuccess() {
  return { type: REGISTER_VERIFY_SUCCESS };
}

/**
 * @description resets all form inputs to initial state
 */
export function resetInputs() {
  return { type: RESET_INPUTS };
}

/**
 * @description resets specific form input errors to initial state
 */
export function resetInputErrors(payload) {
  return {
    payload,
    type: RESET_INPUT_ERRORS,
  };
}

/**
 * @description resets Registration store to initial state
 */
export function resetState() {
  return { type: RESET_STATE };
}

/**
 * @description Action will update redux store with current email provided when the user
 * attempts to login in before clicking the Registration verification link.
 */
export function updateRegisterCurrentEmail(email) {
  return {
    payload: { email },
    type: UPDATE_REGISTER_CURRENT_EMAIL,
  };
}

/**
 * @description On reCaptcha submit, action will send a request to gateway server to verify
 * reCaptcha response
 */
export function verifyRecaptcha(payload) {
  return {
    payload,
    type: VERIFY_RECAPTCHA,
  };
}

/**
 * @description On failed reCaptcha verification request, action will update the redux store
 */
export function verifyRecaptchaFailure() {
  return { type: VERIFY_RECAPTCHA_FAILURE };
}

/**
 * @description On successful reCaptcha verification request, action will update the redux store
 */
export function verifyRecaptchaSuccess() {
  return { type: VERIFY_RECAPTCHA_SUCCESS };
}
